var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3566_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.33325C9.89038 1.33325 7.82809 1.95884 6.07396 3.13091C4.31984 4.30298 2.95267 5.96888 2.14533 7.91796C1.338 9.86704 1.12676 12.0118 1.53834 14.0809C1.94991 16.15 2.96581 18.0506 4.45757 19.5424C5.94933 21.0342 7.84995 22.0501 9.91908 22.4616C11.9882 22.8732 14.1329 22.662 16.082 21.8546C18.0311 21.0473 19.697 19.6801 20.8691 17.926C22.0411 16.1719 22.6667 14.1096 22.6667 11.9999C22.6667 9.17094 21.5429 6.45783 19.5425 4.45745C17.5421 2.45706 14.829 1.33325 12 1.33325ZM2.66671 11.9999C2.66735 9.75717 3.47958 7.59043 4.95338 5.89992L18.1 19.0466C16.748 20.2141 15.0892 20.9691 13.3208 21.2219C11.5524 21.4747 9.74854 21.2147 8.12351 20.4727C6.49847 19.7308 5.1205 18.538 4.15324 17.0361C3.18597 15.5343 2.67004 13.7863 2.66671 11.9999ZM19.0467 18.0999L5.90005 4.95325C7.68895 3.45854 9.97246 2.68738 12.3013 2.7915C14.6301 2.89562 16.8357 3.86747 18.4841 5.51586C20.1325 7.16424 21.1043 9.36982 21.2085 11.6987C21.3126 14.0275 20.5414 16.311 19.0467 18.0999Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3566_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.59c85bda.svg";
export { ForwardRef as ReactComponent };